import React from "react";
import PropTypes from "prop-types";
import Button from "../../utils/Button";
import { useNavigate } from "react-router-dom";
import { ONBOARDING_STATUS } from "../../utils/constants";

const OnboardingStep2 = (props) => {
  const {
    step,
    next,
    verificationLoader,
    handleRowUpdate,
    setStatus,
    formDataStep2,
    setFormDataStep2,
  } = props;
  const navigate = useNavigate();

  const headerStyle = {
    fontSize: "16px",
    fontWeight: "600",
    color: "#3C3C3C",
    margin: "2rem 0rem 1rem 0rem",
  };

  const currentDate = new Date();

  // Format the date as "Nov 15, 2024"
  const formattedDate = currentDate.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormDataStep2({ ...formDataStep2, [name]: value });
  };

  const isFormIncomplete = () => {
    return Object.values(formDataStep2).some((value) => value?.length === 0);
  };

  const handleSubmit = () => {
    const rejectionKeys = Object.keys(formDataStep2)?.filter(
      (key) => formDataStep2[key] === "no"
    );

    const rejectedReasonKeys = rejectionKeys.join();

    if (rejectionKeys?.length > 0) {
      handleRowUpdate({
        updateData: {
          onboardingStatusTime: formattedDate,
          onboardingStatus: {
            status: ONBOARDING_STATUS.SYSTEM_REJECTED,
            reason: rejectedReasonKeys,
          },
        },
      });
      setStatus("rejected");
      navigate("/onboarding/rejected");
    } else {
      next(step);
      handleRowUpdate({
        updateData: {
          onboardingStatus: {
            status: ONBOARDING_STATUS.IN_ONBOARDING_3,
          },
        },
      });
    }
  };

  return (
    <div style={{ width: "100%", color: "#3C3C3C", fontSize: "14px" }}>
      <div style={headerStyle}>Eligibility Check</div>

      {/* Question 1 */}

      <div style={{ lineHeight: "2rem", marginBottom: "0.5rem" }}>
        <p>Are you older than 18 years of age?</p>
        <div style={{ display: "flex", alignItems: "flex-end" }}>
          <label style={{ display: "flex", alignItems: "flex-end" }}>
            <input
              type="radio"
              name="notOlderThan18"
              value="yes"
              checked={formDataStep2.notOlderThan18 === "yes"}
              onChange={handleChange}
              className="m-2 relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white checked:border-primaryBlue checked:bg-primaryBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primaryBlue disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden [&:not(:checked)]:before:hidden"
            />
            <span>Yes</span>
          </label>
          <label
            style={{
              display: "flex",
              alignItems: "flex-end",
              marginLeft: "20px",
            }}
          >
            <input
              type="radio"
              name="notOlderThan18"
              value="no"
              checked={formDataStep2.notOlderThan18 === "no"}
              onChange={handleChange}
              className="m-2 relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white checked:border-primaryBlue checked:bg-primaryBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primaryBlue disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden [&:not(:checked)]:before:hidden"
            />
            <span>No</span>
          </label>
        </div>
      </div>

      {/* Question 2 */}
      <div style={{ lineHeight: "2rem", marginBottom: "0.5rem" }}>
        <p>Are you fluent in English?</p>

        <div style={{ display: "flex", alignItems: "flex-end" }}>
          <label style={{ display: "flex", alignItems: "flex-end" }}>
            <input
              type="radio"
              name="notFluentInEnglish"
              value="yes"
              checked={formDataStep2.notFluentInEnglish === "yes"}
              onChange={handleChange}
              className="m-2 relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white checked:border-primaryBlue checked:bg-primaryBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primaryBlue disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden [&:not(:checked)]:before:hidden"
            />
            <span>Yes</span>
          </label>

          <label
            style={{
              display: "flex",
              alignItems: "flex-end",
              marginLeft: "20px",
            }}
          >
            <input
              type="radio"
              name="notFluentInEnglish"
              value="no"
              checked={formDataStep2.notFluentInEnglish === "no"}
              onChange={handleChange}
              className="m-2 relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white checked:border-primaryBlue checked:bg-primaryBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primaryBlue disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden [&:not(:checked)]:before:hidden"
            />
            <span>No</span>
          </label>
        </div>
      </div>

      {/* Question 3 */}
      <div style={{ lineHeight: "2rem", marginBottom: "0.5rem" }}>
        <p>Do you have a smartphone with international roaming capabilities?</p>

        <div style={{ display: "flex", alignItems: "flex-end" }}>
          <label style={{ display: "flex", alignItems: "flex-end" }}>
            <input
              type="radio"
              name="noSmartphoneRoaming"
              value="yes"
              checked={formDataStep2.noSmartphoneRoaming === "yes"}
              onChange={handleChange}
              className="m-2 relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white checked:border-primaryBlue checked:bg-primaryBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primaryBlue disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden [&:not(:checked)]:before:hidden"
            />
            <span>Yes</span>
          </label>
          <label
            style={{
              display: "flex",
              alignItems: "flex-end",
              marginLeft: "20px",
            }}
          >
            <input
              type="radio"
              name="noSmartphoneRoaming"
              value="no"
              checked={formDataStep2.noSmartphoneRoaming === "no"}
              onChange={handleChange}
              className="m-2 relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white checked:border-primaryBlue checked:bg-primaryBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primaryBlue disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden [&:not(:checked)]:before:hidden"
            />
            <span>No</span>
          </label>
        </div>
      </div>

      {/* Question 4 */}
      <div style={{ lineHeight: "2rem", marginBottom: "0.5rem" }}>
        <p>
          Do you have a valid passport with more than 6 months until expiration
          date?
        </p>
        <div style={{ display: "flex", alignItems: "flex-end" }}>
          <label style={{ display: "flex", alignItems: "flex-end" }}>
            <input
              type="radio"
              name="noValidPassport"
              value="yes"
              checked={formDataStep2.noValidPassport === "yes"}
              onChange={handleChange}
              className="m-2 relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white checked:border-primaryBlue checked:bg-primaryBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primaryBlue disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden [&:not(:checked)]:before:hidden"
            />
            <span>Yes</span>
          </label>
          <label
            style={{
              display: "flex",
              alignItems: "flex-end",
              marginLeft: "20px",
            }}
          >
            <input
              type="radio"
              name="noValidPassport"
              value="no"
              checked={formDataStep2.noValidPassport === "no"}
              onChange={handleChange}
              className="m-2 relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white checked:border-primaryBlue checked:bg-primaryBlue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primaryBlue disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden [&:not(:checked)]:before:hidden"
            />
            <span>No</span>
          </label>
        </div>
      </div>

      <br />
      <Button
        text={"Continue"}
        size={"md"}
        onClick={handleSubmit}
        loading={verificationLoader}
        disabled={isFormIncomplete()}
      />
    </div>
  );
};

OnboardingStep2.propTypes = {
  step: PropTypes.number.isRequired,
  next: PropTypes.func.isRequired,
  back: PropTypes.func.isRequired,
};

export default OnboardingStep2;
